import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { authFetch } from 'api/auth/authFetch'

const fetchData = async (count, page, filter, sort, endpoint, controller) => {
    if (count === 0 || page === 0) return []

    const queryParams = new URLSearchParams({
        pageNumber: page.toString(),
        count: count.toString(),
        ...(filter && { filter: filter.toString() }),
        ...(sort && { sortBy: sort.toString() })
    }).toString()
    const url = `${endpoint}/GetAll?${queryParams}`
    let responseCode = -1

    try {
        const response = await authFetch(url, {
            method: 'GET',
            headers: { "Content-Type": 'application/json' },
            signal: controller.signal
        })

        if(controller.signal?.aborted) return null
        
        responseCode = response.status
        if (responseCode === 200) return await response.json()

        throw {
            Message: 'The AV Landing fetch request was not successful',
            StatusCode: responseCode,
            Details: await response.text()
        }
    } catch (error) {
        throw {
            Message: 'The AV landing fetch request was not successful',
            StatusCode: responseCode,
            Details: error
        }
    }
}

const setUpFetch = (count, page, filter, sort, endpoint) => {
    const controller = new AbortController()
    return {
        controller,
        fetch: () => fetchData(count, page, filter, sort, endpoint, controller)
    }
}

const AudioVisualLandingApi = (props) => {
    const [abortController, setAbortController] = useState(null)
    const [prevParams, setPrevParams] = useState({ page: -1, sort: null, filter: null })
    const { setStatusAction, setResultsAction, requestSelector, setRefreshAction } = props

    /* Dispatch */
    const dispatch = useDispatch()
    const setStatus = (newStatus) => dispatch(setStatusAction(newStatus))
    const setResults = (results) => dispatch(setResultsAction(results))
    const setRefresh = (newRefresh) => dispatch(setRefreshAction(newRefresh))

    /* Selectors */
    const apiRequest = useSelector(requestSelector)
    const { count, page, filter, sort, url, status, refresh } = apiRequest

    if(prevParams.page === page && prevParams.filter === filter && prevParams.sort === sort && !refresh) {
        return undefined
    }

    setPrevParams({ page, filter, sort})
    setRefresh(false)

    if (status === 'pending' && abortController) abortController.abort()
    if (status.status === 'pending') return

    setStatus({ status: 'pending' })
    const { controller, fetch } = setUpFetch(count, page, filter, sort, url)
    setAbortController(controller)

    fetch()
        .then(results => {
            if (results) {
                setResults(results)
                setStatus({ status: 'complete' })
            }
        })
        .catch(error => {
            setResults({})
            setStatus({ status: 'error', error })
        })

    return undefined
}

export default AudioVisualLandingApi
